if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.addEventListener('mousemove', (event) => {
          event.stopImmediatePropagation();
        });

        this.goUpArrow = this.querySelector(".product-media-go-up-arrow");

        this.goUpArrow.addEventListener('click', (event) =>  {
          event.stopImmediatePropagation();
          this.setAsActiveMediaAccordingToDirection("up");
        });

        this.goDownArrow = this.querySelector(".product-media-go-down-arrow");

        this.goDownArrow.addEventListener("click", (event) => {
          event.stopImmediatePropagation();
          this.setAsActiveMediaAccordingToDirection("down");
        });

        this.allMediaElements = Array.from(this.querySelectorAll(`[data-media-id]`));

        window.addEventListener("keydown", (event) =>
          this.handleArrowsKeyDownEvents(event)
        );

        this.allMediaElements.forEach(mediaElement => {
          mediaElement.addEventListener('click', (event) => {
            event.stopImmediatePropagation();
          });

          let options = {
            root: this,
            rootMargin: '0px',
            threshold: 0.5
          }

          let observer = new IntersectionObserver(this.intersectionObserverCallback, options);
          observer.observe(mediaElement);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      intersectionObserverCallback = (entries, observer) => {

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const activeElementMediaIndex = this.allMediaElements.findIndex(
              (x) => x.dataset.mediaId == entry.target.dataset.mediaId
            );

            if (activeElementMediaIndex > -1) {
              this.activeMediaElementIndex = activeElementMediaIndex;
              this.activeMediaElement = this.allMediaElements[this.activeMediaElementIndex];
              this.setInitialArrowStatuses();
            }
          }
        });
      };

      handleArrowsKeyDownEvents(event) {
        if (event.key !== undefined) {
          if (event.key === "ArrowUp") {
            // to mimic disabled buttons
            if (this.activeMediaElementIndex == 0) {
              return true;
            }

            this.setAsActiveMediaAccordingToDirection("up");
          }

          if (event.key === "ArrowDown") {
            // to mimic disabled buttons
            if (this.activeMediaElementIndex == this.allMediaElements.length - 1) {
              return true;
            }

            this.setAsActiveMediaAccordingToDirection("down");
          }
        }
      }

      setAsActiveMediaAccordingToDirection(direction) {
        // removes active from all media items
        this.allMediaElements.forEach((element) =>
          element.classList.remove("active")
        );

        // go up or down
        if (direction == "down") {
          // always allow to go up when down arrow is clicked
          this.goUpArrow.classList.remove("disabled");
          if(this.goDownArrow.classList.contains("disabled")) {
              return;
          }

          // disable down arrow before last item
          if (this.activeMediaElementIndex >= this.allMediaElements.length - 2) {
            this.goDownArrow.classList.add("disabled");
          }

          // increment current index
          this.activeMediaElementIndex += 1;
        } else {
          // always allow to go down when up arrow is clicked
          this.goDownArrow.classList.remove("disabled");

          if(this.goUpArrow.classList.contains("disabled")) {
            return;
        }

          // disable up before first item
          if (this.activeMediaElementIndex <= 1) {
            this.goUpArrow.classList.add("disabled");
          }

          this.activeMediaElementIndex -= 1;
        }

        // new activate media
        this.activeMediaElement = this.allMediaElements[this.activeMediaElementIndex];
        this.setActiveMediaClasses();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove("active");
        });

        this.activeMediaElement = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        );

        this.activeMediaElementIndex = this.allMediaElements.indexOf(
          this.activeMediaElement
        );

        this.setInitialArrowStatuses();
        this.setActiveMediaClasses({ isOnOpen: true });
      }

      setActiveMediaClasses(options) {
        if(!this.activeMediaElement) {
          return;
        }
        const activeMediaTemplate = this.activeMediaElement.querySelector("template");

        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        this.activeMediaElement.classList.add("active");

        if (options?.isOnOpen) {
          this.activeMediaElement.scrollIntoView();
          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (this.activeMediaElement.width - container.clientWidth) / 2;

        } else {
          this.activeMediaElement.scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
        }

        if (this.activeMediaElement.nodeName == "DEFERRED-MEDIA" && activeMediaContent && activeMediaContent.querySelector(".js-youtube")) {
          this.activeMediaElement.loadContent();
        }
      }

      setInitialArrowStatuses() {
        this.goDownArrow.classList.remove("disabled");
        this.goUpArrow.classList.remove("disabled");

        // disable up at first item
        if (this.activeMediaElementIndex == 0) {
          this.goUpArrow.classList.add("disabled");
        }

        // disable down at last item
        if (this.activeMediaElementIndex == this.allMediaElements.length - 1) {
          this.goDownArrow.classList.add("disabled");
        }
      }
    }
  );
}
